const matchers = [
  (s, t) => (s.plate || "").toUpperCase() === t,
  (s, t) => (s.assigned_plate || "").toUpperCase() === t,
  (s, t) => (s.plate || "").toUpperCase().includes(t),
  (s, t) => (s.assigned_plate || "").toUpperCase().includes(t),
  (s, t) => (s.driver || "").toUpperCase().includes(t),
  (s, t) => (s.assigned_to || "").toUpperCase().includes(t),
];

export const findSpace = (spaces, term) => {
  const t = term.trim().toUpperCase();
  if (!t) return null;
  for (const match of matchers) {
    const hit = spaces.find((s) => match(s, t));
    if (hit) return hit;
  }
  return /^\d+$/.test(t) ? spaces.find((s) => s.number === Number(t)) || null : null;
};
